/**
 * The columns of the charters table, as one set of names.
 *
 * Shared by the store (which decides what is visible), the column selector (which offers them) and
 * the row (which reads what it is allowed to draw), so a column cannot be added to one and missed by
 * another — a mismatch there hides a column that is ticked, or draws one that is not.
 */
export const CharterColumnKeys = {
	REFERENCE: 'humanReadableId',
	NAME: 'name',
	CUSTOMER: 'customer',
	FERRY: 'ferry',
	START_DATE: 'startDateTime',
	END_DATE: 'endDateTime',
	PRICE: 'price',
	STATUS: 'status',
	PAYMENT: 'payment',
	INVOICE_NUMBER: 'invoiceNumber',
} as const;

export type CharterColumnKey = (typeof CharterColumnKeys)[keyof typeof CharterColumnKeys];
